import React from 'react';
import {
  TextStyle,
  Stack,
} from '@shopify/polaris';

function ResourceCounts(props) {

  return (
    <Stack>
      <Stack.Item>
        <p>Total: <TextStyle variation="strong">{props.totalResourceCount}</TextStyle>.</p>
      </Stack.Item>
      <Stack.Item>
        <p>Matching Filter Conditions: <TextStyle variation="strong">{props.matchingResourceCount}</TextStyle>.</p>
      </Stack.Item>
      <Stack.Item>
        <p>Current page: <TextStyle variation="strong">{props.currentResourceCount}</TextStyle>.</p>
      </Stack.Item>
    </Stack>
  );

}

export default ResourceCounts;